import { Box, Button, List, Stack, Typography } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import Iconify from "minimals-template/components/Iconify"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { PagedRepeat } from "lib/@components/paged-repeat"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { createBundle, getBundles } from "../controller/auth-bundles.controller"
import { AuthBundleDialog } from "./auth-bundle-dialog"
import { AuthBundleRow } from "./auth-bundle-row"

export function AuthBundles() {
    const create = useDialog(<AuthBundleDialog />, { maxWidth: "md", fullWidth: true })
    const bundles = getBundles.useResults({}, withInitialValue(IS_LOADING))

    if (bundles === IS_LOADING) return <LoadingScreen />
    if (!bundles) return null

    return (
        <>
            <Stack mx={1} mb={2} spacing={2}>
                <Typography variant="body2" color="text.secondary">
                    Auth Bundles are predefined sets of permissions packaged together for internal use. These bundles
                    allow users to quickly and efficiently gain a specific set of permissions tailored for different
                    functionalities, scenarios, or features.
                </Typography>
                <Box>
                    <Button
                        data-cy="admin-add-bundle-button"
                        startIcon={<Iconify icon="mdi:account-lock" />}
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                    >
                        Add Bundle
                    </Button>
                </Box>
            </Stack>
            <List className="custom-skills">
                <PagedRepeat showTop list={bundles.sortBy("name")} item={<AuthBundleRow />} pageSize={5} />
            </List>
        </>
    )

    async function onConfirm() {
        const newBundle = await create()
        if (!newBundle) return
        try {
            await createBundle(newBundle)
        } catch (error) {
            console.error(error)
            errorSnackbar(error?.toString())
        }
    }
}
